import { render, staticRenderFns } from "./TemplateNewOrEdit.vue?vue&type=template&id=ec7805cc&"
import script from "./TemplateNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./TemplateNewOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports